import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { LinkedOrderModificationRequestImpl } from "../model/impl/LinkedOrderModificationRequestImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class LinkedOrderModificationRequestImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(
    encodable: LinkedOrderModificationRequestImpl,
    streamout: CubiqTS.ByteBuffer,
  ): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.product != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(1),
        false,
        encodable.product,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.comment1 != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(2),
        false,
        encodable.comment1,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.comment2 != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(3),
        false,
        encodable.comment2,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.client != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(4),
        false,
        encodable.client,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.account != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(5),
        false,
        encodable.account,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.linkReference != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(6),
        false,
        encodable.linkReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.rootOrder != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(7),
        true,
        encodable.rootOrder,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.clientTrader != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(9),
        false,
        encodable.clientTrader,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.stpHold != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(10),
        false,
        encodable.stpHold,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    if (encodable.savedOrder != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(11),
        false,
        encodable.savedOrder,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.oboClient != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(12),
        false,
        encodable.oboClient,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.oboAccount != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(13),
        false,
        encodable.oboAccount,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.oboUser != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(14),
        false,
        encodable.oboUser,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.cancelAndReplace != null) {
      this.baseEncoder.writeStartFid(101, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(101),
        false,
        encodable.cancelAndReplace,
        streamout,
      );
      this.baseEncoder.writeEndFid(101, streamout);
    }
    /*Object encoding*/
    if (encodable.privatisedRequest != null) {
      this.baseEncoder.writeStartFid(102, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(102),
        false,
        encodable.privatisedRequest,
        streamout,
      );
      this.baseEncoder.writeEndFid(102, streamout);
    }
    /*Object encoding*/
    if (encodable.clientReference != null) {
      this.baseEncoder.writeStartFid(103, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(103),
        false,
        encodable.clientReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(103, streamout);
    }
    /*Object encoding*/
    if (encodable.existingOrderReference != null) {
      this.baseEncoder.writeStartFid(104, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(104),
        false,
        encodable.existingOrderReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(104, streamout);
    }
    /*Object encoding*/
    if (encodable.makerReference != null) {
      this.baseEncoder.writeStartFid(105, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(105),
        false,
        encodable.makerReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(105, streamout);
    }
    /*Object encoding*/
    if (encodable.clientStrategyReference != null) {
      this.baseEncoder.writeStartFid(106, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(106),
        false,
        encodable.clientStrategyReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(106, streamout);
    }
    /*Object encoding*/
    if (encodable.existingStrategyReference != null) {
      this.baseEncoder.writeStartFid(107, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(107),
        false,
        encodable.existingStrategyReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(107, streamout);
    }
    /*Object encoding*/
    if (encodable.brokerId != null) {
      this.baseEncoder.writeStartFid(200, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(200),
        false,
        encodable.brokerId,
        streamout,
      );
      this.baseEncoder.writeEndFid(200, streamout);
    }
    /*Object encoding*/
    if (encodable.secureToken != null) {
      this.baseEncoder.writeStartFid(300, streamout);
      this.baseEncoder.writeObject(
        false,
        LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(300),
        true,
        encodable.secureToken,
        streamout,
      );
      this.baseEncoder.writeEndFid(300, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "com.bcdfx.model.Product"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.String"],
    [7, "com.bcdfx.model.event.lifecycle.OrderRequestDataImpl"],
    [9, "java.lang.String"],
    [10, "java.lang.Boolean"],
    [11, "java.lang.Boolean"],
    [12, "java.lang.String"],
    [13, "java.lang.String"],
    [14, "java.lang.String"],
    [100, "java.lang.String"],
    [101, "java.lang.Boolean"],
    [102, "java.lang.Boolean"],
    [103, "java.lang.String"],
    [104, "java.lang.String"],
    [105, "java.lang.String"],
    [106, "java.lang.String"],
    [107, "java.lang.String"],
    [200, "java.lang.String"],
    [300, "com.bcdfx.security.SecureToken"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: LinkedOrderModificationRequestImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Product = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.product = <CubiqTS.Product>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.comment1 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.comment2 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.client = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.account = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.linkReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.OrderRequestDataImpl = this.baseEncoder.readObject(
            true,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.rootOrder = <CubiqTS.OrderRequestDataImpl>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.clientTrader = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.stpHold = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.savedOrder = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.oboClient = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.oboAccount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.oboUser = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 101: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(101),
            streamin,
          );
          encodable.cancelAndReplace = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 102: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(102),
            streamin,
          );
          encodable.privatisedRequest = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 103: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(103),
            streamin,
          );
          encodable.clientReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 104: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(104),
            streamin,
          );
          encodable.existingOrderReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 105: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(105),
            streamin,
          );
          encodable.makerReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 106: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(106),
            streamin,
          );
          encodable.clientStrategyReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 107: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(107),
            streamin,
          );
          encodable.existingStrategyReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 200: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(200),
            streamin,
          );
          encodable.brokerId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 300: {
          /*Object encoding*/
          let val: CubiqTS.SecureToken = this.baseEncoder.readObject(
            true,
            false,
            LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(300),
            streamin,
          );
          encodable.secureToken = <CubiqTS.SecureToken>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010: {
          /*Object encoding*/
          let val_10010:string=this.baseEncoder.readObject(false,false,LinkedOrderModificationRequestImplEncoder.fidTypeMap.get(10010),streamin);
          encodable.sessionOnly=val_10010;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return LinkedOrderModificationRequestImplEncoder.fidTypeMap.has(fid);
  }
}
